const EVENT = "incident-data-changed";

export const notifyIncidentChange = () => {
  window.dispatchEvent(new Event(EVENT));
  if ("BroadcastChannel" in window) {
    const channel = new BroadcastChannel(EVENT);
    channel.postMessage("changed");
    channel.close();
  }
  // Fallback for browsers without BroadcastChannel. No incident data in browser storage.
  try { localStorage.setItem(EVENT, String(Date.now())); } catch { /* Storage may be unavailable. */ }
};

export const subscribeIncidentChanges = callback => {
  window.addEventListener(EVENT, callback);
  const storage = event => { if (event.key === EVENT) callback(); };
  window.addEventListener("storage", storage);
  const channel = "BroadcastChannel" in window ? new BroadcastChannel(EVENT) : null;
  if (channel) channel.onmessage = callback;
  return () => {
    window.removeEventListener(EVENT, callback);
    window.removeEventListener("storage", storage);
    channel?.close();
  };
};